import { ChangeDetectionStrategy, Component } from '@angular/core';

/** A section title between dropdown items; not itself selectable. */
@Component({
  selector: 'app-content-dropdown-heading-cabinet',
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { role: 'presentation' },
  styles: [`
    :host {
      display: block;
      padding: 0.25rem 0.75rem 0.375rem;
      font-size: var(--font-size-xs);
      line-height: var(--line-height-body);
      color: var(--secondary-text-color);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: default;
    }

    :host(:not(:first-child)) {
      padding-top: 0.5rem;
    }
  `],
})
export class ContentDropdownHeadingCabinetComponent {}
